/*
 * This store holds the data for the course-options page of the calcualtor
 *
 */
const axios = require("axios");

const state = {
};

const mutations = {
};

const actions = {
   searchCourses({ state, commit, rootState, rootGetters }, payload){
      //payload.id = encodeURI(payload.id)
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + "/api/curriculum/courseSearch/", { payload })
         .then(response => {
            resolve(response.data)
         })
         .catch(err => {
            let error = err.response.data.response
            reject(error);
         });
      })
   },
   getCourse({ state, commit, rootState, rootGetters }, id){
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + "/api/curriculum/course/", { id })
         .then(response => {
            resolve(response.data)
         })
         .catch(err => {
            let error = err.response.data.response
            reject(error);
         });
      })
   },
   getConditionSet({ state, commit, rootState, rootGetters }, query){
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + "/api/curriculum/getConditionSet/", { query })
         .then(response => {
            var resp = {items: [], links: response.data.links};
            var acceptableQueries = ["subject", "major", "co_major", "minor"];
            var q = query.substring(query.indexOf('=')+1, query.indexOf('?'))
            if(!acceptableQueries.includes(q)){
               q = query.substring(0, query.indexOf('&'))
            }
            switch(q){
               case "subject":
                  response.data.conditionSet.subject = response.data.conditionSet.subject.filter(
                     subject =>
                        subject.status.value === "Active" &&
                        subject.callista_version_number
                  );
                  resp.items = response.data.conditionSet.subject.map(subject => {
                     return {
                        name: subject.unit_title,
                        credits: parseFloat(subject.credit_points),
                        code: subject.unit_code,
                        id: subject.unit_code + "v" + subject.callista_version_number,
                        order: "0",
                        description: "",
                        sourceSystemId: subject.cl_id,
                        type: "Unit",
                        version: subject.version_name,
                        fieldOfEducation: {
                           detailed: subject.detailed_field_of_education.value
                        }
                     };
                  });
               break;
               case "major":
                  response.data.conditionSet.major = response.data.conditionSet.major.filter(
                     major =>
                        major.status.value === "Active" &&
                        major.callista_version_number
                  );
                  resp.items = response.data.conditionSet.major.map(major => {
                     return {
                        name: major.major_title,
                        credits: parseFloat(major.credit_points),
                        code: major.major_code,
                        id: major.major_code + "v" + major.callista_version_number,
                        order: "0",
                        description: "",
                        sourceSystemId: major.cl_id,
                        type: "Major",
                        version: major.version_name
                     };
                  });
               break;
               case "co_major":
                  response.data.conditionSet.co_major = response.data.conditionSet.co_major.filter(
                     comajor =>
                        comajor.status.value === "Active" &&
                        comajor.callista_version_number
                  );
                  resp.items = response.data.conditionSet.co_major.map(comajor => {
                     return {
                        name: comajor.co_major_title,
                        credits: parseFloat(comajor.credit_points),
                        code: comajor.co_major_code,
                        id: comajor.co_major_code + "v" + comajor.callista_version_number,
                        order: "0",
                        description: "",
                        sourceSystemId: comajor.cl_id,
                        type: "Co-Major",
                        versionNumber: comajor.version_name
                     };
                  });
               break;
               case "minor":
                  response.data.conditionSet.minor = response.data.conditionSet.minor.filter(
                     minor =>
                        minor.status.value === "Active" &&
                        minor.callista_version_number
                  );
                  resp.items = response.data.conditionSet.minor.map(minor => {
                     return {
                        name: minor.minor_title,
                        credits: parseFloat(minor.credit_points),
                        code: minor.minor_code,
                        id: minor.minor_code + "v" + minor.callista_version_number,
                        order: "0",
                        description: "",
                        sourceSystemId: minor.cl_id,
                        type: "Minor",
                        versionNumber: minor.version_name
                     };
                  });
               break;
               default:
                  //console.log("default hit");
            }
            /*****************************************  AND END  ***************************************************/
            resolve(resp)
         })
         .catch(err => {
            let error = err.response.data.response
            reject(error);
         });
      })
   },
   searchConditionSet({ state, commit, rootState, rootGetters }, query){
      //query = encodeURI(query)
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + "/api/curriculum/searchConditionSet/", { query })
         .then(response => {
            var resp = {items: [], links: response.data.links};
            var acceptableQueries = ["subject", "major", "co_major", "minor"];
            var q = query.substring(query.indexOf('=')+1, query.indexOf('?'))
            if(!acceptableQueries.includes(q)){
               q = query.substring(0, query.indexOf('&'))
            }
            switch(q){
               case "subject":
                  response.data.conditionSet.subject = response.data.conditionSet.subject.filter(
                     subject =>
                        subject.status.value === "Active" &&
                        subject.callista_version_number
                  );
                  resp.items = response.data.conditionSet.subject.map(subject => {
                     return {
                        name: subject.unit_title,
                        credits: parseFloat(subject.credit_points),
                        code: subject.unit_code,
                        id: subject.unit_code + "v" + subject.callista_version_number,
                        order: "0",
                        description: "",
                        sourceSystemId: subject.cl_id,
                        type: "Unit",
                        version: subject.version_name,
                        fieldOfEducation: {
                           detailed: subject.detailed_field_of_education.value
                        }
                     };
                  });
               break;
               case "major":
                  response.data.conditionSet.major = response.data.conditionSet.major.filter(
                     major =>
                        major.status.value === "Active" &&
                        major.callista_version_number
                  );
                  resp.items = response.data.conditionSet.major.map(major => {
                     return {
                        name: major.major_title,
                        credits: parseFloat(major.credit_points),
                        code: major.major_code,
                        id: major.major_code + "v" + major.callista_version_number,
                        order: "0",
                        description: "",
                        sourceSystemId: major.cl_id,
                        type: "Major",
                        version: major.version_name
                     };
                  });
               break;
               case "co_major":
                  response.data.conditionSet.co_major = response.data.conditionSet.co_major.filter(
                     comajor =>
                        comajor.status.value === "Active" &&
                        comajor.callista_version_number
                  );
                  resp.items = response.data.conditionSet.co_major.map(comajor => {
                     return {
                        name: comajor.co_major_title,
                        credits: parseFloat(comajor.credit_points),
                        code: comajor.co_major_code,
                        id: comajor.co_major_code + "v" + comajor.callista_version_number,
                        order: "0",
                        description: "",
                        sourceSystemId: comajor.cl_id,
                        type: "Co-Major",
                        versionNumber: comajor.version_name
                     };
                  });
               break;
               case "minor":
                  response.data.conditionSet.minor = response.data.conditionSet.minor.filter(
                     minor =>
                        minor.status.value === "Active" &&
                        minor.callista_version_number
                  );
                  resp.items = response.data.conditionSet.minor.map(minor => {
                     return {
                        name: minor.minor_title,
                        credits: parseFloat(minor.credit_points),
                        code: minor.minor_code,
                        id: minor.minor_code + "v" + minor.callista_version_number,
                        order: "0",
                        description: "",
                        sourceSystemId: minor.cl_id,
                        type: "Minor",
                        versionNumber: minor.version_name
                     };
                  });
               break;
               default:
                  //console.log("default hit");
            }
            /*****************************************  AND END  ***************************************************/
            resolve(resp)
         })
         .catch(err => {
            let error = err.response.data.response
            reject(error);
         });
      })
   },
   getMajor({ state, commit, rootState, rootGetters }, id){
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + "/api/curriculum/majors-units/", { id })
         .then(response => {
            resolve(response.data)
         })
         .catch(err => {
            let error = err.response.data.response
            reject(error);
         });
      })
   },
   getCoMajor({ state, commit, rootState, rootGetters }, id){
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + "/api/curriculum/co-major-units/", { id })
         .then(response => {
            resolve(response.data)
         })
         .catch(err => {
            let error = err.response.data.response
            reject(error);
         });
      })
   },
   getMinor({ state, commit, rootState, rootGetters }, id){
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + "/api/curriculum/minor-units/", { id })
         .then(response => {
            resolve(response.data)
         })
         .catch(err => {
            let error = err.response.data.response
            reject(error);
         });
      })
   },
   searchUnits({ state, commit, rootState, rootGetters }, keywords){
      //keywords = encodeURI(keywords)
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + "/api/curriculum/searchUnits/", { keywords })
         .then(response => {
            resolve(response.data)
         })
         .catch(err => {
            let error = err.response.data.response
            reject(error);
         });
      })
   },
   getUnit({ state, commit, rootState, rootGetters }, id){
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + "/api/curriculum/units/", { id })
         .then(response => {
            resolve(response.data)
         })
         .catch(err => {
            let error = err.response.data.response
            reject(error);
         });
      })
   },
   getPage({ state, commit, rootState, rootGetters }, query){
      return new Promise((resolve, reject) => {
         axios
         .post(BaseURL + "/api/curriculum/page/", { query })
         .then(response => {
            resolve(response.data)
         })
         .catch(err => {
            let error = err.response.data.response
            reject(error);
         });
      })
   },
};

export default {
   state,
   actions,
   mutations
};
